import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiRequest } from '../lib/api';
import type { AppointmentWithClient } from '../types/appointment';

async function fetchSingleAppointment(
  appointmentId: string,
  accessToken: string | null | undefined,
) {
  // Use the global appointments endpoint with ID as a filter
  const appointments = await apiRequest<AppointmentWithClient[]>(
    `/api/appointments?id=${appointmentId}`,
    { method: 'GET' },
    accessToken,
  );

  if (!appointments || appointments.length === 0) {
    throw new Error('Appointment not found');
  }

  return appointments[0];
}

export function useSingleAppointment(appointmentId: string) {
  const { session } = useAuth();

  return useQuery<AppointmentWithClient>({
    queryKey: ['appointment', appointmentId],
    enabled: Boolean(appointmentId && session),
    queryFn: () => fetchSingleAppointment(appointmentId, session?.access_token),
  });
}
